import { useParams } from "react-router-dom";
import { useVolunteerData } from "../hooks/useVolunteerData";
import styles from "./PublicVolunteerDetail.module.scss";
import { CircularProgress, Alert, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { SkillsInterestsList } from "../components/SkillsInterestsList/SkillsInterestsList";
import { useTranslation } from "../i18n";

export const PublicVolunteerDetail = () => {
  const { t } = useTranslation();
  const { volunteerId } = useParams<{ volunteerId: string }>();
  const { data, loading, error } = useVolunteerData(volunteerId!);

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <CircularProgress />
          <p>{t("volunteer.loadingProfile")}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <Alert severity="error">
            {t(error)}
            {t("eventDetail.signInForMore")}
          </Alert>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <Alert severity="warning">{t("volunteer.notFound")}</Alert>
        </div>
      </div>
    );
  }

  const profileImage = 'profile_image' in data ? data.profile_image : undefined;

  return (
    <div className={styles.container}>
      <div className={styles.publicBadge}>
        <Chip 
          label={t("volunteer.publicBadge")}
          size="small"
        />
      </div>

      <div className={styles.header}>
        <div className={styles.avatar}>
          {profileImage ? (
            <img src={profileImage as string} alt={`${data.first_name} ${data.last_name}`} />
          ) : (
            <PersonIcon sx={{ fontSize: 80 }} />
          )}
        </div>
        <div className={styles.headerInfo}>
          <h1>
            {data.first_name} {data.last_name}
          </h1>
        </div>
      </div>

      <div className={styles.content}>
        {data.skills && data.skills.length > 0 && (
          <section className={styles.section || ''}>
            <SkillsInterestsList 
              items={data.skills} 
              type="skills" 
              title={t("volunteer.skills")} 
              emptyMessage={t("volunteer.noSkillsOther")}
            />
          </section>
        )}

        {data.interests && data.interests.length > 0 && (
          <section className={styles.section || ''}>
            <SkillsInterestsList 
              items={data.interests} 
              type="interests" 
              title={t("volunteer.interests")} 
              emptyMessage={t("volunteer.noInterestsOther")}
            />
          </section>
        )}

        <div className={styles.loginInfo}>
          <Alert severity="info">
            {t("volunteer.signInForMore")}
          </Alert>
        </div>
      </div>
    </div>
  );
};

